import { proxyBE, proxyApiMnemo } from "./common";
import { mnemoService } from "libs/api";

export const adminService = {
  course(payload) {
    return proxyBE.get(`admin/course/${JSON.stringify(payload)}`);
  },
  loadAllCourse(payload) {
    return proxyBE.get(`admin/course/${JSON.stringify(payload)}`);
  },
  insertCourse(payload) {
    return proxyBE.post(`admin/course`, payload);
  },
  updateCourse(payload) {
    return proxyBE.put(`admin/course`, payload);
  },
  willDeleted(payload) {
    return proxyBE.put(`admin/course`, payload);
  },
  deleteCourse(id) {
    return proxyBE.delete(`admin/course/${id}`);
  },
  importCourse(payload) {
    return proxyBE.post(`admin/import`, payload);
  },
  courseSection(idCourse) {
    return proxyBE.get(`sections/idparent/${idCourse}`);
  },
  insertSection(payload) {
    return proxyBE.post(`sections/`, payload);
  },
  updateSection(payload) {
    return proxyBE.put(`sections/`, payload);
  },
  loadCourseFromMoodle(courseCode) {
    const payload = mnemoService.buildPayload(
      "courseByShortName",
      "shortname",
      courseCode,
    );
    return proxyApiMnemo.get("moodleExporter/?payload=" + encodeURI(payload));
  },
  verifyPayment(registrationCode) {
    const payload = mnemoService.buildPayloadObject("verifyPaymentOther", {
      registrationCode: registrationCode,
    });
    return proxyApiMnemo.post("payment/", payload);
  },

  importQuizFromMoodle(payload) {
    return proxyBE.post(`admin/importQuiz`, payload);
  },
  deleteSection(id) {
    return proxyBE.delete(`sections/${id}`);
  },

  insertLesson(payload) {
    return proxyBE.post(`admin/lessons/`, payload);
  },
  updateLesson(payload) {
    return proxyBE.put(`admin/lessons/`, payload);
  },
  deleteLesson(id) {
    return proxyBE.delete(`admin/lessons/${id}`);
  },
  insertLessonAndResource(payload) {
    return proxyBE.post(`admin/lessonsandresource/`, payload);
  },
  updatetLessonAndResource(payload) {
    return proxyBE.put(`admin/lessonsandresource/`, payload);
  },
  loadLessonAndResource(id) {
    return proxyBE.get(`admin/lessonsandresource/${id}`);
  },
  insertQuizQuestions(payload) {
    return proxyBE.post(`admin/quiz/question`, payload);
  },
  quizAllQuestion(idQuiz) {
    return proxyBE.get(`admin/quiz/allquestion/${idQuiz}`);
  },
  deleteQuestion(id) {
    return proxyBE.delete(`admin/quiz/question/${id}`);
  },
  updateQuizQuestions(payload) {
    return proxyBE.put(`admin/quiz/question`, payload);
  },
  loadAnwsers(idQuestion) {
    return proxyBE.get(`admin/quiz/answer/${idQuestion}`);
  },
  deleteAnswer(id) {
    return proxyBE.delete(`admin/quiz/answer/${id}`);
  },
  insertQuestionsAnswer(payload) {
    return proxyBE.post(`admin/quiz/answer`, payload);
  },
  updateQuestionsAnswer(payload) {
    return proxyBE.put(`admin/quiz/answer`, payload);
  },
  courseType(payload) {
    return proxyBE.get(`admin/courseType/${JSON.stringify(payload)}`);
  },
  loadAllCourseType(payload) {
    return proxyBE.get(`admin/courseType/${JSON.stringify(payload)}`);
  },
  updateCourseType(payload) {
    return proxyBE.put(`admin/courseType`, payload);
  },
  insertCourseType(payload) {
    return proxyBE.post(`admin/courseType`, payload);
  },
  deleteCourseType(id) {
    return proxyBE.delete(`admin/courseType/${id}`);
  },
  quizByIDParent(idResource) {
    return proxyBE.get(`admin/quizByIdParent/${idResource}`);
  },
  insertQuiz(payload) {
    return proxyBE.post(`admin/quiz/insert`, payload);
  },
  updateQuiz(payload) {
    return proxyBE.post(`admin/quiz/update`, payload);
  },
  getUser(filter) {
    return proxyBE.get(`admin/user/${JSON.stringify(filter)}`);
  },
  getUserBySearch(filter) {
    return proxyBE.get(`admin/getUserBySearch/${JSON.stringify(filter)}`);
  },
  getUDAByExamDate(filter) {
    return proxyBE.get(`admin/getUDAByExamDate/${JSON.stringify(filter)}`);
  },
  changeUserStatus(id) {
    return proxyBE.put(`admin/user/change-status/${id}`);
  },
  deleteRequestGDPRConfirmed(id) {
    return proxyBE.put(`admin/user/delete-for-gdpr/${id}`);
  },
  changeUserReadOnly(payload) {
    return proxyBE.put(`admin/user/change-readonly`, payload);
  },
  deleteUser(id) {
    return proxyBE.delete(`admin/user/${id}`);
  },
  userDetail(filter) {
    return proxyBE.get(`admin/user/detail/${JSON.stringify(filter)}`);
  },
  collectAndSendTo(uid) {
    return proxyBE.get(`admin/user/collect/${uid}`);
  },
  collectUserEnrollment(uid) {
    return proxyBE.get(`admin/user/enrollment/${uid}`);
  },
  loadAllRepoQuiz(payload) {
    return proxyBE.get(`admin/repoquiz/${JSON.stringify(payload)}`);
  },
  cloneToRepository(payload) {
    return proxyBE.post(`admin/clonetorepository`, payload);
  },
  deleteRepoQuiz(id) {
    return proxyBE.delete(`admin/repoquiz/${id}`);
  },
  insertRepoQuiz(payload) {
    return proxyBE.post(`admin/repoquiz`, payload);
  },
  updateRepoQuiz(payload) {
    return proxyBE.put(`admin/repoquiz`, payload);
  },
  quizRepoAllQuestion(idQuiz) {
    return proxyBE.get(`admin/repoquiz/allquestion/${idQuiz}`);
  },
  deleteRepoQuestion(id) {
    return proxyBE.delete(`admin/repoquiz/question/${id}`);
  },
  loadRepoAnwsers(idQuestion) {
    return proxyBE.get(`admin/repoquiz/answer/${idQuestion}`);
  },
  loadResource(idResource) {
    return proxyBE.get(`admin/resources/${idResource}`);
  },

  deleteRepoAnswer(id) {
    return proxyBE.delete(`admin/repoquiz/answer/${id}`);
  },

  updateRepoQuizQuestions(payload) {
    return proxyBE.put(`admin/repoquiz/question`, payload);
  },

  insertRepoQuizQuestions(payload) {
    return proxyBE.post(`admin/repoquiz/question`, payload);
  },

  insertRepoQuestionsAnswer(payload) {
    return proxyBE.post(`admin/repoquiz/answer`, payload);
  },

  updateRepoQuestionsAnswer(payload) {
    return proxyBE.put(`admin/repoquiz/answer`, payload);
  },

  syncUserDataTo(reportUserData) {
    const payload = mnemoService.buildPayloadObject("", reportUserData);
    return proxyApiMnemo.post("admin/syncUserDataTo", payload);
  },
  syncEnrollmentDataTo(resEnrollment) {
    const payload = mnemoService.buildPayloadObject("", resEnrollment);
    return proxyApiMnemo.post("admin/syncEnrollmentDataTo", payload);
  },
  getPromotional(payload) {
    return proxyBE.get(`admin/promotional/${JSON.stringify(payload)}`);
  },
  deletePromotional(id) {
    return proxyBE.delete(`admin/promotional/${id}`);
  },
  changePromotionalStatus(id) {
    return proxyBE.put(`admin/promotional/change-status/${id}`);
  },
  insertPromotional(payload) {
    return proxyBE.post(`admin/promotional`, payload);
  },
  updatePromotional(payload) {
    return proxyBE.put(`admin/promotional`, payload);
  },
  verifyPromotionalCode(filter) {
    return proxyBE.get(`admin/promotional/verify/${JSON.stringify(filter)}`);
  },
  registerOnUserCourse(payload) {
    return proxyBE.post(`admin/user/registerOnUserCource/`, payload);
  },
  cloneFullModule(payload) {
    return proxyBE.post(`admin/course/cloneFullModule`, payload);
  },
  studentUpdateSyncIn(payload) {
    return proxyBE.put(`admin/studentpdate/sync-in`, payload);
  },
  userUpdateSyncIn(payload) {
    return proxyBE.post(`admin/studentpdate/update-user`, payload);
  },
  cloneFullCourse(payload) {
    return proxyBE.post(`admin/course/cloneFullCourse`, payload);
  },
  remotetestloadwait() {
    const payload = mnemoService.buildPayload("latatency", "shortname", 0);
    return proxyApiMnemo.get("test/?payload=" + encodeURI(payload));
  },
  getSiteconfig() {
    return proxyBE.get(`admin/siteconfig/`);
  },
  getSiteconfigDetail(id) {
    return proxyBE.get(`admin/siteconfig/${id}`);
  },
  insertSiteconfig(payload) {
    return proxyBE.post(`admin/siteconfig`, payload);
  },
  updateSiteconfig(payload) {
    return proxyBE.put(`admin/siteconfig`, payload);
  },
  loadAllBlogCategory(payload) {
    return proxyBE.get(`admin/blog-category/${JSON.stringify(payload)}`);
  },
  deleteBlogCategory(id) {
    return proxyBE.delete(`admin/blog-category/${id}`);
  },
  updateBlogcategory(payload) {
    return proxyBE.put(`admin/blog-category`, payload);
  },
  insertBlogcategory(payload) {
    return proxyBE.post(`admin/blog-category`, payload);
  },
  loadBlogArticlesByIdCategory(payload) {
    return proxyBE.get(`admin/blog-articles/${JSON.stringify(payload)}`);
  },
  deleteBlogArticle(id) {
    return proxyBE.delete(`admin/blog-article/${id}`);
  },
  loadBlogArticle(id) {
    return proxyBE.get(`admin/blog-article-detail/${id}`);
  },
  updateBlogArticle(payload) {
    return proxyBE.put(`admin/blog-article`, payload);
  },
  insertBlogArticle(payload) {
    return proxyBE.post(`admin/blog-article`, payload);
  },
  loadSurveys() {
    return proxyBE.get(`admin/surveys`);
  },
  loadSurvey(id) {
    return proxyBE.get(`admin/survey/${id}`);
  },
  insertSurvey(payload) {
    return proxyBE.post(`admin/survey`, payload);
  },
  updateSurvey(payload) {
    return proxyBE.put(`admin/survey`, payload);
  },

  loadSurveyQuestions(idSurvey) {
    return proxyBE.get(`admin/survey/questions/${idSurvey}`);
  },
  insertSurveyQuestion(payload) {
    return proxyBE.post(`admin/survey/question`, payload);
  },
  updateSurveyQuestion(payload) {
    return proxyBE.put(`admin/survey/question`, payload);
  },
  deleteSurveyQuestion(id) {
    return proxyBE.delete(`admin/survey/question/${id}`);
  },

  loadSurveyAnswers(idQuestion) {
    return proxyBE.get(`admin/survey/answers/${idQuestion}`);
  },
  insertSurveyAnswer(payload) {
    return proxyBE.post(`admin/survey/answer`, payload);
  },
  updateSurveyAnswer(payload) {
    return proxyBE.put(`admin/survey/answer`, payload);
  },
  deleteSurveyAnswer(id) {
    return proxyBE.delete(`admin/survey/answer/${id}`);
  },

  loadPages() {
    return proxyBE.get(`admin/pages`);
  },
  deletePage(id) {
    return proxyBE.delete(`admin/page/${id}`);
  },
  loadPage(id) {
    return proxyBE.get(`admin/page/${id}`);
  },
  updatePage(payload) {
    return proxyBE.put(`admin/page`, payload);
  },
  insertPage(payload) {
    return proxyBE.post(`admin/page`, payload);
  },
  loadAllLibraryCategory(payload) {
    return proxyBE.get(`admin/library-category/${JSON.stringify(payload)}`);
  },
  deleteLibraryCategory(id) {
    return proxyBE.delete(`admin/library-category/${id}`);
  },
  insertLibrarycategory(payload) {
    return proxyBE.post(`admin/library-category`, payload);
  },
  updateLibrarycategory(payload) {
    return proxyBE.put(`admin/library-category`, payload);
  },
  insertLibraryauthor(payload) {
    return proxyBE.post(`admin/library-author`, payload);
  },
  loadAllLibraryAuthor(payload) {
    return proxyBE.get(`admin/library-author/${JSON.stringify(payload)}`);
  },
  deleteLibraryAuthor(id) {
    return proxyBE.delete(`admin/library-author/${id}`);
  },
  updateLibraryauthor(payload) {
    return proxyBE.put(`admin/library-author`, payload);
  },
  loadAllLibraryBook(payload) {
    return proxyBE.get(`admin/library-book/${JSON.stringify(payload)}`);
  },
  deleteLibraryBook(id) {
    return proxyBE.delete(`admin/library-book/${id}`);
  },
  insertLibrarybook(payload) {
    return proxyBE.post(`admin/library-book`, payload);
  },
  updateLibrarybook(payload) {
    return proxyBE.put(`admin/library-book`, payload);
  },
  insertUserEnrollmentAbilitation(payload) {
    return proxyBE.post(`admin/user/enrollment-abilitation`, payload);
  },
  loadAllAudioAssetCategory() {
    return proxyBE.get(`admin/audio-asset-category`);
  },
  loadAudioAssetCategory(id) {
    return proxyBE.get(`admin/audio-asset-category/${id}`);
  },
  insertAudioCategory(payload) {
    return proxyBE.post(`admin/audio-asset-category`, payload);
  },
  updateAudioCategory(payload) {
    return proxyBE.put(`admin/audio-asset-category`, payload);
  },
  deleteAudioCategory(id) {
    return proxyBE.delete(`admin/audio-asset-category/${id}`);
  },
  loadAudioAssetByCategory(idAudioCategory) {
    return proxyBE.get(`admin/audio-asset-file-by-category/${idAudioCategory}`);
  },
  loadAudioAssetByKey(key) {
    return proxyBE.get(`admin/audio-asset-file-by-key/${key}`);
  },
  loadAudioAssetByOriginalName(originalName) {
    return proxyBE.get(
      `admin/audio-asset-file-by-originalname/${originalName}`,
    );
  },
  insertAudioFile(payload) {
    return proxyBE.post(`admin/audio-asset-file`, payload);
  },
  updateAudioFile(payload) {
    return proxyBE.put(`admin/audio-asset-file`, payload);
  },
  deleteAudioFile(idAudioCategory) {
    return proxyBE.delete(`admin/audio-asset-file/${idAudioCategory}`);
  },
  loadAudioAsset(idAudioCategory, idAudio) {
    return proxyBE.get(`admin/audio-asset-file/${idAudioCategory}/${idAudio}`);
  },
  updateVerifyCF(payload) {
    return proxyBE.put(`admin/user/updateVerifyCF`, payload);
  },
  listAllContactRequest(type) {
    return proxyBE.get(`admin/contactRequest/listAll/${type}`);
  },
  loadContactRequests(payload) {
    return proxyBE.get(`admin/contactRequest/${JSON.stringify(payload)}`);
  },
  exportContactRequests(type) {
    return proxyBE.get(`admin/contactRequest/export/${type}`, {
      responseType: "blob",
    });
  },
  exportContactRequestSummary(type) {
    return proxyBE.get(`admin/contactRequest/export-summary/${type}`, {
      responseType: "blob",
    });
  },
  loadLessonLiveSchedule(payload) {
    return proxyBE.get(`admin/lessonLiveSchedule/${JSON.stringify(payload)}`);
  },
  loadLessonOnSiteSchedule(payload) {
    return proxyBE.get(`admin/lessonOnSiteSchedule/${JSON.stringify(payload)}`);
  },
  loadTrainingSchedule(payload) {
    return proxyBE.get(`admin/trainingSchedule/${JSON.stringify(payload)}`);
  },
  loadLessonOnSiteAttendees(payload) {
    const { idLesson, lessonType } = payload;
    return proxyBE.get(`admin/lessonOnSiteAttendees/${idLesson}/${lessonType}`);
  },
  loadTrainingAttendees(payload) {
    const { idLesson, lessonType } = payload;
    return proxyBE.get(
      `admin/lessonTrainingAttendees/${idLesson}/${lessonType}`,
    );
  },
  deleteLessonLiveSchedule(id) {
    return proxyBE.delete(`admin/lessonLiveSchedule/${id}`);
  },
  deleteLessonOnSiteSchedule(id) {
    return proxyBE.delete(`admin/lessonOnSiteSchedule/${id}`);
  },
  deleteTrainingSchedule(id) {
    return proxyBE.delete(`admin/trainingSchedule/${id}`);
  },
  updateLessonLiveSchedule(payload) {
    return proxyBE.put(`admin/lessonLiveSchedule`, payload);
  },
  updateLessonOnSiteSchedule(payload) {
    return proxyBE.put(`admin/lessonOnSiteSchedule`, payload);
  },
  updateTrainingSchedule(payload) {
    return proxyBE.put(`admin/trainingSchedule`, payload);
  },
  insertLessonLiveSchedule(payload) {
    return proxyBE.post(`admin/lessonLiveSchedule`, payload);
  },
  insertLessonOnSiteSchedule(payload) {
    return proxyBE.post(`admin/lessonOnSiteSchedule`, payload);
  },
  insertTrainingSchedule(payload) {
    return proxyBE.post(`admin/trainingSchedule`, payload);
  },
  loadLessonLiveClass(payload) {
    return proxyBE.get(`admin/lessonLiveClass/${JSON.stringify(payload)}`);
  },
  updateLessonLiveClass(payload) {
    return proxyBE.put(`admin/lessonLiveClass`, payload);
  },
  insertLessonLiveClass(payload) {
    return proxyBE.post(`admin/lessonLiveClass`, payload);
  },

  loadLessonLiveClassMaterials() {
    return proxyBE.get(`admin/lessonLiveClass/materials/listAll`);
  },

  loadLessonLiveClassMaterial(id) {
    return proxyBE.get(`admin/lessonLiveClass/material/${id}`);
  },

  insertLessonLiveClassMaterial(payload) {
    return proxyBE.post("/admin/lessonLiveClass/material/", payload);
  },

  updateLessonLiveClassMaterial(payload) {
    return proxyBE.put("/admin/lessonLiveClass/material/", payload);
  },

  deleteLessonLiveClassMaterial(id) {
    return proxyBE.delete(`admin/lessonLiveClass/material/${id}`);
  },

  loadDataSetToDownload(idClass) {
    return proxyBE.get(`admin/lessonLiveClassBooking/${idClass}`);
  },
  loadDataSetToDownloadCSV(idClass, competitionClass, idLesson) {
    return proxyBE.get(
      `admin/lessonLiveClassBooking/${idClass}/${competitionClass}/${idLesson}`,
    );
  },

  insertLessonLiveAnalyticsSlido(idLessonLiveSchedule) {
    return proxyBE.post(
      `admin/lessonLiveAnalytics/slido/`,
      idLessonLiveSchedule,
    );
  },

  insertLessonLiveAnalyticsWebex(idLessonLiveSchedule) {
    return proxyBE.post(`admin/lessonLiveAnalytics/webex/`, {
      idLessonLiveSchedule,
    });
  },

  insertLessonTrainingAnalyticsWebex(idLessonTrainingSchedule) {
    return proxyBE.post(`admin/lessonTrainingAnalytics/webex/`, {
      idLessonTrainingSchedule,
    });
  },
  enableAttendance(idLessonLiveSchedule) {
    return proxyBE.put(`admin/lessonLiveAnalytics/webex/attendace-enable/`, {
      idLessonLiveSchedule,
      enable: true,
    });
  },
  enableAttendanceTraining(idLessonTrainingSchedule) {
    return proxyBE.put(
      `admin/lessonTrainingAnalytics/webex/attendace-enable/`,
      {
        idLessonTrainingSchedule,
        enable: true,
      },
    );
  },
  disableAttendance(idLessonLiveSchedule) {
    return proxyBE.put(`admin/lessonLiveAnalytics/webex/attendace-enable/`, {
      idLessonLiveSchedule,
      enable: false,
    });
  },
  listStudents(examSite, idExamSession, academicYear) {
    return proxyBE.get(
      `admin/lessonLiveAnalytics/user-list-by-site/${examSite}/${idExamSession}/${academicYear}`,
    );
  },

  lessonLiveAnalytics(examSite, idExamSession, academicYear) {
    return proxyBE.post(
      `admin/lessonLiveAnalytics/webex-resume-examSite/${examSite}/${idExamSession}/${academicYear}`,
    );
  },

  lessonLiveAnalyticStudent(registrationCode, academicYear, fourHour = false) {
    return proxyBE.post("admin/lessonLiveAnalytics/webex-resume-user/", {
      registrationCode,
      academicYear,
      fourHour,
    });
  },
  loadLessonLiveEdition(payload) {
    return proxyBE.get(`admin/lessonLiveEdition/${JSON.stringify(payload)}`);
  },
  updateLessonLiveEdition(payload) {
    return proxyBE.put(`admin/lessonLiveEdition`, payload);
  },
  insertLessonLiveEdition(payload) {
    return proxyBE.post(`admin/lessonLiveEdition`, payload);
  },
  loadLessonLiveEditionExamSession() {
    return proxyBE.get(`admin/lessonLiveEditionExamSession`);
  },
  loadLessonLiveCalendarWebexAccountGroup(archivied) {
    if (archivied === "undefined") archivied = "";
    return proxyBE.get(`admin/loadLessonLiveCalendarWebexAccountGroup`);
  },
  loadLessonTrainingCalendarWebexAccountGroup(archivied) {
    if (archivied === "undefined") archivied = "";
    return proxyBE.get(`admin/loadTrainingCalendarWebexAccountGroup`);
  },
  loadLessonLiveCalendarWebexAccountGroupExport(payload) {
    return proxyBE.post(
      `admin/loadLessonLiveCalendarWebexAccountGroupExport`,
      payload,
    );
  },
  loadLessonTrainingCalendarWebexAccountGroupExport(payload) {
    return proxyBE.post(
      `admin/loadTrainingCalendarWebexAccountGroupExport`,
      payload,
    );
  },
  loadLessonStudentSchedule(courseId, rCode) {
    return proxyBE.get(`/admin/student-lesson-schedule/${courseId}/${rCode}`);
  },

  loadFullSetToDownload(idClass, date, hourStart) {
    return proxyBE.get(
      `admin/lessonLiveClassBooking/full/dataset/` +
        idClass +
        `/` +
        date +
        `/` +
        hourStart,
    );
  },
  getDataByQrRegistrationCode(
    registrationCode,
    idLessonSchedule,
    lessonType,
    currentRegion,
  ) {
    return proxyBE.get(
      `admin/getDataByQrRegistrationCode/${registrationCode}/${idLessonSchedule}/${lessonType}/${currentRegion}`,
    );
  },
  uploadLessonLiveClassCalendar(payload) {
    return proxyBE.post(`admin/lessonLiveClassCalendar/webex/upload`, payload);
  },
  uploadLessonLiveRegistrationID(payload) {
    return proxyBE.post(`admin/lessonLiveRegistrationID/webex/upload`, payload);
  },
  uploadLessonLiveRegistrationIDByAccountExt(payload) {
    return proxyBE.post(
      `admin/lessonLiveRegistrationID/webex/uploadByAccountExt`,
      payload,
    );
  },
  uploadLessonTrainingRegistrationIDByAccountExt(payload) {
    return proxyBE.post(
      `admin/trainingRegistrationID/webex/uploadByAccountExt`,
      payload,
    );
  },
  uploadJsonRepoQuizFull(payload) {
    return proxyBE.post(`admin/repoQuiz/uploadJsonRepoQuizFull`, payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  exportAttendees(idLessonLiveSchedule) {
    return proxyBE.get(
      `admin/lessonLiveScheduleExportAttendees/${idLessonLiveSchedule}`,
    );
  },
  exportAttendeesOnSite(idLessonLiveSchedule) {
    return proxyBE.get(
      `admin/lessonOnSiteScheduleExportAttendees/${idLessonLiveSchedule}`,
    );
  },
  exportAttendeesTraining(idLessonTrainingSchedule) {
    return proxyBE.get(
      `admin/trainingScheduleExportAttendees/${idLessonTrainingSchedule}`,
    );
  },
  toggleOnSiteAttendance(payload) {
    return proxyBE.put("admin/lessonOnSiteSchedule/toggle-attendance", payload);
  },
  toggleTrainingAttendance(payload) {
    return proxyBE.put(
      "admin/lessonTrainingSchedule/toggle-attendance",
      payload,
    );
  },
  insertRevisor(payload) {
    return proxyBE.post("admin/revisor", payload);
  },
  updateRevisor(payload) {
    return proxyBE.put("admin/revisor", payload);
  },
  deleteUserEnrollmentAttachmentFile(idParent) {
    return proxyBE.delete(`enrollment/attachment-file-idParent/${idParent}`);
  },
  importFromGOMP(payload, currentAA) {
    return proxyBE.post(
      `admin-tfa-indire-gomp/importfromgomp/${currentAA}`,
      payload,
    );
  },
  ImportFromGompClassic(payload, currentAA) {
    return proxyBE.post(
      `admin-tfa-classic-gomp/importfromgomp/${currentAA}`,
      payload,
    );
  },
  confirmBando(currentAA) {
    return proxyBE.get(`admin-tfa-indire-gomp/bando/confirm/${currentAA}`);
  },
  confirmImmatricolazione(currentAA, courseType) {
    return proxyBE.get(`admin-tfa-classic-gomp/bando/confirm/${currentAA}/${courseType}`);
  },
  ImportFromContingente(payload) {
    return proxyBE.post("admin/importfromcontingente", payload);
  },
  ImportRecognitionCFUtd(payload) {
    return proxyBE.post("admin/importrecognitioncfutd", payload);
  },
  saveLessonLiveScheduleTrainings(payload) {
    return proxyBE.put("admin/lessonLiveSchedule/trainings", payload);
  },
  deleteLessonLiveScheduleTraining(id) {
    return proxyBE.delete(`admin/lessonLiveSchedule/training/${id}`);
  },
  saveLessonTrainingScheduleTrainings(payload) {
    return proxyBE.put("admin/lessonTrainingSchedule/trainings", payload);
  },
  deleteLessonTrainingScheduleTraining(id) {
    return proxyBE.delete(`admin/lessonTrainingSchedule/training/${id}`);
  },
  loadLessonLiveAccessAnomaly() {
    return proxyBE.get(`/admin/lessonLiveAccessAnomaly`);
  },
  loadLessonTrainingAccessAnomaly() {
    return proxyBE.get(`/admin/lessonTrainingAccessAnomaly`);
  },
  fixAccessAnomalyWebExLive(payload) {
    return proxyBE.put("admin/lessonLiveWebex/fix-access-anomaly", payload);
  },
  fixAccessAnomalyWebExTraining(payload) {
    return proxyBE.put("admin/lessonTrainingWebex/fix-access-anomaly", payload);
  },
  popolateSelectQrCode() {
    return proxyBE.get(`qrcode/popolateSelectQrCode`);
  },
  getQrCodeList(payload) {
    return proxyBE.get(`qrcode/qrcodelist/${JSON.stringify(payload)}`);
  },
  generateQrCode(payload) {
    return proxyBE.post(`qrcode/generateqrcode`, payload);
  },
  popolateModalSelectQrCode() {
    return proxyBE.get(`qrcode/popolateModalSelectQrCode`);
  },
  getLessonActivityArchives() {
    return proxyBE.get("admin/lesson-activity-archive/list");
  },
  createLessonActivityArchive(payload) {
    return proxyBE.post("admin/lesson-activity-archive", payload);
  },
  downloadLessonActivityArchive(id) {
    return proxyBE.get(`admin/lesson-activity-archive/download/${id}`);
  },
};
